import SearchOff from "@mui/icons-material/SearchOffOutlined";
import Box from "@mui/material/Box";
import ListItem from "@mui/material/ListItem";
import Typography from "@mui/material/Typography";
import type {FC, ReactElement} from "react";

type EmptyStateProps = {
  title?: string;
  subtitle?: string;
  icon?: ReactElement;
};

const EmptyState: FC<EmptyStateProps> = props => {
  const {
    title = "Not found",
    subtitle = "No data found.",
    icon = <SearchOff sx={{fontSize: 48, color: "text.disabled", mb: 2}} />,
  } = props;

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
      height="100%">
      <ListItem
        sx={{
          py: 4,
          flexDirection: "column",
          textAlign: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}>
        {icon}
        <Typography variant="body1" color="text.secondary" fontWeight={500}>
          {title}
        </Typography>
        <Typography variant="body2" color="text.disabled">
          {subtitle}
        </Typography>
      </ListItem>
    </Box>
  );
};

export default EmptyState;
